import type { Plan } from '@/modules/auth/stores/types'
import { formatCredits } from '../../utils/planPricing'

export const PlanCredits = ({ plan }: { plan: Plan }) => {
  return (
    <>
      <p className="mt-6 text-sm">
        <span className="font-semibold tabular-nums">
          {formatCredits(plan)} credits
        </span>
        <span className="text-muted-foreground"> included to start</span>
      </p>
      <p className="mt-1 text-xs text-muted-foreground text-pretty">
        One credit reads one page of a bank or card statement. Denser pages,
        like tax forms, use two.
      </p>
    </>
  )
}
